import { AxiosResponse } from "axios";
import { QUERY_CLIENT } from "..";
import { QueryKeys } from "./base/react-query";
import CompanySetting, { CompanySecretKey } from "../model/company-setting";
import { getAxiosInstance } from "./api-utils";
const COMPANY_SETTINGS = "/company-settings";

export async function getCompanySettings(skipErrorToast = false): Promise<CompanySetting> {
    const response: AxiosResponse<CompanySetting> = await getAxiosInstance({ skipErrorInterceptor: skipErrorToast }).get(COMPANY_SETTINGS);
    return response.data;
}

/** Saves the public settings only; secrets go through setCompanySecret / clearCompanySecret. */
export async function updateCompanySettings(companySetting: Pick<CompanySetting, "name" | "mapboxToken">) {
    await getAxiosInstance().patch(`${COMPANY_SETTINGS}`, { name: companySetting.name, mapboxToken: companySetting.mapboxToken });
    QUERY_CLIENT.invalidateQueries(QueryKeys.companySettings);
}

export async function setCompanySecret(key: CompanySecretKey, value: string) {
    await getAxiosInstance().put(`${COMPANY_SETTINGS}/secrets/${key}`, { value });
    QUERY_CLIENT.invalidateQueries(QueryKeys.companySettings);
}

export async function clearCompanySecret(key: CompanySecretKey) {
    await getAxiosInstance().delete(`${COMPANY_SETTINGS}/secrets/${key}`);
    QUERY_CLIENT.invalidateQueries(QueryKeys.companySettings);
}

export interface GeocodedPlace {
    lat: number;
    lon: number;
    displayName: string;
}

/** Address → coordinates via our backend (which holds the geocoding key). */
export async function geocodeAddress(query: string): Promise<GeocodedPlace[]> {
    const response: AxiosResponse<GeocodedPlace[]> = await getAxiosInstance().get("/geocoding/search", { params: { q: query } });
    return response.data;
}
